<template>
  <div class="download">
    <!-- 页面头部 -->
    <section class="page-header">
      <div class="container">
        <h1>产品下载</h1>
        <p>同时支持 PC、IOS、Android 操作系统</p>
      </div>
    </section>

    <section class="robot-download section">
      <div class="container">
        <div class="download-section">
          <h2 class="download-title">掌柜助手</h2>
          <p class="download-subtitle">同时支持iOS、Android版本</p>
          
          <div class="download-cards">
            <div class="download-card card" :style="{ order: isAndroid ? 2 : 1 }">
              <div class="download-icon">📱</div>
              <h3>iOS版本</h3>
              <p>支持iPhone和iPad设备</p>
              <p class="version-info">支持TF签、企业签、超级签等多种安全下载途径</p>
              <div class="download-buttons">
                <a href="#" class="btn btn-primary" @click="handleDownload('ios1')">
                  用户端
                </a>
                <span style="width: 10px;display: inline-block;"></span>
                <a href="#" class="btn btn-primary" @click="handleDownload('ios2')">
                  群主端
                </a>
                <!-- <p class="download-tip">单击鼠标右键可复制下载链接</p> -->
              </div>
            </div>

            <div class="download-card card" :style="{ order: isAndroid ? 1 : 2 }">
              <div class="download-icon">🤖</div>
              <h3>Android版本</h3>
              <p>支持Android手机和平板</p>
              <p class="version-info">原生APP，安全稳定，功能完整</p>
              <div class="download-buttons">
                <a href="#" class="btn btn-primary" @click="handleDownload('android1')">
                  用户端
                </a>
                <span style="width: 10px;display: inline-block;"></span>
                <a href="#" class="btn btn-primary" @click="handleDownload('android2')">
                  群主端
                </a>
                <!-- <p class="download-tip">单击鼠标右键可复制下载链接</p> -->
              </div>
            </div>
          </div>

          <div class="features-list">
            <h3>APP功能特色</h3>
            <div class="features-grid">
              <div class="feature-item">
                <div class="feature-icon">🎮</div>
                <h4>全功能支持</h4>
                <p>支持WEB助手所有功能和设置</p>
              </div>
              <div class="feature-item">
                <div class="feature-icon">💬</div>
                <h4>实时消息</h4>
                <p>群内消息实时查看，不错过任何机会</p>
              </div>
              <div class="feature-item">
                <div class="feature-icon">⚡</div>
                <h4>极速推送</h4>
                <p>申请消息极速推送</p>
              </div>
              <div class="feature-item">
                <div class="feature-icon">📱</div>
                <h4>移动便捷</h4>
                <p>摆脱电脑束缚，走到哪玩到哪</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 技术支持 -->
    <section class="support section">
      <div class="container">
        <h2 class="section-title">技术支持</h2>
        <div class="support-content">
          <div class="support-cards">
            <div class="support-card card">
              <div class="support-icon">🛠️</div>
              <h3>远程协助</h3>
              <p>专业技术人员提供一对一远程协助服务</p>
              <!-- <a href="#" class="btn btn-secondary">联系技术</a> -->
            </div>
            <div class="support-card card">
              <div class="support-icon">📞</div>
              <h3>在线客服</h3>
              <p>服务时间：早9点到晚上12点，随时为您解答</p>
              <!-- <a href="https://t.me/ZG000001" class="btn">在线咨询</a> -->
            </div>
            <div class="support-card card">
              <div class="support-icon">🔄</div>
              <h3>版本更新</h3>
              <p>定期更新版本，修复问题，优化性能</p>
              <!-- <a href="#" class="btn btn-secondary">检查更新</a> -->
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 下载统计 -->
    <section class="download-stats section">
      <div class="container">
        <div class="stats-content">
          <div class="stat-item">
            <div class="stat-number">10,000+</div>
            <div class="stat-label">总下载量</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">5,000+</div>
            <div class="stat-label">活跃用户</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">99.9%</div>
            <div class="stat-label">稳定性</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">24/7</div>
            <div class="stat-label">技术支持</div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Download',
  data() {
    return {
      isAndroid: /Android/i.test(navigator.userAgent)
    }
  },
  mounted() {
    this.animateOnScroll()
  },
  methods: {
    handleDownload(type) {
      // 模拟下载功能
      const downloads = {
        ios1: 'user.mobileconfig',
        ios2: 'room.mobileconfig',
        android1: 'user.apk',
        android2: 'room.apk'
      }
      
      // alert(`正在准备${downloads[type]}...`)
      // 这里可以添加实际的下载逻辑
      window.location.href = downloads[type];
    },
    animateOnScroll() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in')
          }
        })
      })

      const elements = document.querySelectorAll('.card, .step-item, .stat-item')
      elements.forEach(el => observer.observe(el))
    }
  }
}
</script>

<style scoped>
.page-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 80px 0 60px;
  text-align: center;
}

.page-header h1 {
  font-size: 42px;
  font-weight: bold;
  margin-bottom: 15px;
}

.page-header p {
  font-size: 18px;
  opacity: 0.9;
}

.download-section {
  margin-bottom: 60px;
}

.download-title {
  font-size: 32px;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin-bottom: 10px;
}

.download-subtitle {
  font-size: 18px;
  color: #666;
  text-align: center;
  margin-bottom: 40px;
}

.download-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;
  margin-bottom: 50px;
}

.download-card {
  text-align: center;
  padding: 40px 30px;
  transition: all 0.3s ease;
}

.download-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
}

.download-icon {
  font-size: 64px;
  margin-bottom: 20px;
}

.download-card h3 {
  font-size: 24px;
  color: #333;
  margin-bottom: 15px;
}

.download-card p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 10px;
}

.version-info {
  font-size: 14px;
  color: #999;
  font-style: italic;
  margin-bottom: 25px !important;
}

.download-buttons {
  margin-top: 25px;
}

.download-tip {
  font-size: 12px;
  color: #999;
  margin-top: 10px;
  font-style: italic;
}

.features-list, .system-requirements {
  margin-top: 50px;
}

.features-list h3, .system-requirements h3 {
  font-size: 24px;
  color: #333;
  text-align: center;
  margin-bottom: 30px;
}

.features-grid, .requirements-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 25px;
}

.feature-item, .requirement-item {
  background: white;
  padding: 25px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: all 0.3s ease;
}

.feature-item:hover, .requirement-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
}

.feature-icon, .requirement-icon {
  font-size: 32px;
  margin-bottom: 15px;
}

.feature-item h4, .requirement-item h4 {
  font-size: 18px;
  color: #333;
  margin-bottom: 10px;
}

.feature-item p, .requirement-item p {
  color: #666;
  font-size: 14px;
  line-height: 1.5;
}

.assistant-download {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.installation-guide {
  background: white;
}

.guide-steps {
  max-width: 800px;
  margin: 0 auto;
}

.step-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 40px;
  opacity: 0;
  transform: translateX(-30px);
  transition: all 0.6s ease;
}

.step-item.animate-in {
  opacity: 1;
  transform: translateX(0);
}

.step-number {
  width: 50px;
  height: 50px;
  background: linear-gradient(45deg, #667eea, #764ba2);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  margin-right: 25px;
  flex-shrink: 0;
}

.step-content h3 {
  font-size: 20px;
  color: #333;
  margin-bottom: 10px;
}

.step-content p {
  color: #666;
  line-height: 1.6;
}

.support {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  color: white;
}

.support .section-title {
  color: white;
}

.support-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.support-card {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  text-align: center;
  padding: 40px 30px;
}

.support-icon {
  font-size: 48px;
  margin-bottom: 20px;
}

.support-card h3 {
  font-size: 22px;
  color: #3498db;
  margin-bottom: 15px;
}

.support-card p {
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.6;
  margin-bottom: 25px;
}

.download-stats {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.stats-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 40px;
  text-align: center;
}

.stat-item {
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.6s ease;
}

.stat-item.animate-in {
  opacity: 1;
  transform: translateY(0);
}

.stat-number {
  font-size: 48px;
  font-weight: bold;
  margin-bottom: 10px;
  background: linear-gradient(45deg, #fff, #f0f8ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.stat-label {
  font-size: 16px;
  opacity: 0.9;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .page-header {
    padding: 60px 0 40px;
  }
  
  .page-header h1 {
    font-size: 32px;
  }
  
  .download-title {
    font-size: 28px;
  }
  
  .download-cards {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .features-grid, .requirements-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .support-cards {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .stats-content {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
  }
  
  .step-item {
    flex-direction: column;
    text-align: center;
  }
  
  .step-number {
    margin-right: 0;
    margin-bottom: 15px;
  }
}
</style>
